import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randAlphaNumeric } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'

type BatchModel = SchemaAttributes<'Batch'>

export const model = Model as ModelDefinition<BatchModel>

export const factory = Factory.extend<BatchModel>({
  batch_number() {
    return randAlphaNumeric({ length: 10 }).join('')
  },
})
